import {
  EfficiencyFlag,
  type EfficiencyFlagProps,
} from '@packages/shared/src/components/EfficiencyFlag/EfficiencyFlag';
import { useIntl } from 'react-intl';
import { efficiencyFlagMessages } from './messages';

type LegacyEfficiencyFlagProps = EfficiencyFlagProps;

export const LegacyEnergyEfficiencyFlag = ({ ...flagProps }: LegacyEfficiencyFlagProps) => {
  const { formatMessage } = useIntl();

  return (
    <EfficiencyFlag {...flagProps} title={formatMessage(efficiencyFlagMessages[flagProps.type])} />
  );
};
